import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Icon } from '@millionshow/client-libs';

interface ScheduleItem {
  time: string;
  description: string;
}

interface DaySchedule {
  date: string;
  title: string;
  items: ScheduleItem[];
}

@Component({
  selector: 'app-preparation-schedule',
  standalone: true,
  imports: [CommonModule, Icon],
  templateUrl: './preparation-schedule.component.html',
})
export class PreparationScheduleComponent {
  schedules: DaySchedule[] = [
    {
      date: '2025-01-01',
      title: '설치일',
      items: [
        { time: '09:00~18:00', description: '조립부스 설치, 독립부스 설치' },
        { time: '14:00~22:00', description: '참가업체 내부 디스플레이' },
      ],
    },
    {
      date: '2025-01-02',
      title: '행사 1일차',
      items: [
        { time: '09:00~10:00', description: '전시회 OPEN 준비' },
        { time: '10:00~18:00', description: '전시회 OPEN' },
        { time: '17:30', description: '입장마감' },
        { time: '18:00', description: '1일차 행사 종료' },
      ],
    },
    {
      date: '2025-01-03',
      title: '행사 2일차',
      items: [
        { time: '09:00~10:00', description: '전시회 OPEN 준비' },
        { time: '10:00~18:00', description: '전시회 OPEN' },
        { time: '17:30', description: '입장마감' },
        { time: '18:00', description: '2일차 행사 종료' },
      ],
    },
    {
      date: '2025-01-04',
      title: '행사 3일차',
      items: [
        { time: '09:00~10:00', description: '전시회 OPEN 준비' },
        { time: '10:00~18:00', description: '전시회 OPEN' },
        { time: '17:30', description: '입장마감' },
        { time: '18:00', description: '3일차 행사 종료' },
      ],
    },
    {
      date: '2025-01-05',
      title: '행사 4일차',
      items: [
        { time: '09:00~10:00', description: '전시회 OPEN 준비' },
        { time: '10:00~18:00', description: '전시회 OPEN' },
        { time: '17:30', description: '입장마감' },
        { time: '18:00', description: '4일차 행사 종료' },
      ],
    },
    {
      date: '2025-01-06',
      title: '종료일',
      items: [
        { time: '09:00~10:00', description: '전시회 OPEN 준비' },
        { time: '10:00~18:00', description: '전시회 OPEN' },
        { time: '17:30', description: '입장마감' },
        { time: '18:00', description: '5일차 행사 종료' },
        { time: '18:00~22:00', description: '참가업체 철수 및 부스 철거' },
      ],
    },
  ];
}
